const getBrandFlag = (brand) => {
  switch (brand) {
    case 'anf':
      return '1';
    case 'kids':
      return '2';
    default:
      return '3';
  }
};

const getNoImageFoundUrl = (brand) => {
  const brandFlag = getBrandFlag(brand);
  return `https://img.abercrombie.com/is/image/anf/KIC_${brandFlag}XX-XXXX-XXXX-XXX?policy=product-large`;
};

export default getNoImageFoundUrl;
